import React, { useMemo, useContext } from 'react';
import { GlobalContext } from '../../context-provider';
import { SliderContext } from './';
export var useSliderIcon = function useSliderIcon(_ref) {
  var valueGroup = _ref.valueGroup;

  var _useContext = useContext(GlobalContext),
      _useContext$prefixCls = _useContext.prefixCls,
      prefixCls = _useContext$prefixCls === void 0 ? '' : _useContext$prefixCls;

  var _useContext2 = useContext(SliderContext),
      max = _useContext2.max,
      suffixLabel = _useContext2.suffixLabel,
      min = _useContext2.min,
      prefixLabel = _useContext2.prefixLabel;

  var renderPrefixLabel = useMemo(function () {
    if (!prefixLabel) return null;
    var inner;

    if (typeof prefixLabel === 'boolean' && prefixLabel) {
      inner = /*#__PURE__*/React.createElement(React.Fragment, null, min);
    } else if (typeof prefixLabel === 'function') {
      inner = prefixLabel(valueGroup);
    } else {
      inner = prefixLabel;
    }

    return /*#__PURE__*/React.createElement("div", {
      className: prefixCls + "-slider-label is-prefix"
    }, inner);
  }, [min, prefixLabel, valueGroup]);
  var renderSuffixLabel = useMemo(function () {
    if (!suffixLabel) return null;
    var inner;

    if (typeof suffixLabel === 'boolean' && suffixLabel) {
      inner = /*#__PURE__*/React.createElement(React.Fragment, null, max);
    } else if (typeof suffixLabel === 'function') {
      inner = suffixLabel(valueGroup);
    } else {
      inner = suffixLabel;
    }

    return /*#__PURE__*/React.createElement("div", {
      className: prefixCls + "-slider-label is-suffix"
    }, inner);
  }, [max, suffixLabel, valueGroup]);
  return {
    renderPrefixLabel: renderPrefixLabel,
    renderSuffixLabel: renderSuffixLabel
  };
};